import { render, staticRenderFns } from "./KpisByMunicipioDataTable.vue?vue&type=template&id=0f4a8c85&"
import script from "./KpisByMunicipioDataTable.vue?vue&type=script&lang=js&"
export * from "./KpisByMunicipioDataTable.vue?vue&type=script&lang=js&"
import style0 from "./KpisByMunicipioDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VProgressCircular,VTextField,VTooltip})
